// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_marketplace_marketplace_module_ts":"e796ede986c9c28b","src_app_pages_inventory_inventory_module_ts":"eae194dc97f14c54","src_app_pages_buy-coins_buy-coins_module_ts":"2cce2e5407055c6a"}[chunkId] + ".js";
};